<template>
  <div id="formParametrosEmpresa">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="PARÁMETROS EMPRESA" color="primary darken-4" dark>
            <div slot="widget-content">
              <v-card-text>
                <v-container grid-list-md>
                  <v-form
                    ref="formParametrosEmpresa"
                    :v-model="true"
                    lazy-validation
                  >
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Nombre de la empresa *"
                        v-model="parametrosEmpresa.nombreEmpresa"
                        placeholder="Nombre Empresa"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.nombreEmpresa ||
                            'El campo es requerido',
                        ]"
                        :counter="120"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Razón Social *"
                        v-model="parametrosEmpresa.razonSocial"
                        placeholder="Razón Social de la Empresa"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.razonSocial ||
                            'El campo es requerido',
                        ]"
                        :counter="200"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="RFC *"
                        v-model="parametrosEmpresa.rfc"
                        placeholder="Registro Federal de Contribuyentes"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.rfc || 'El campo es requerido',
                        ]"
                        :counter="13"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Domicilio Fiscal*"
                        v-model="parametrosEmpresa.domicilioFiscal"
                        placeholder="Domicilio Fiscal"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.domicilioFiscal ||
                            'El campo es requerido',
                        ]"
                        :counter="255"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        label="Política Renta *"
                        v-model="parametrosEmpresa.politicaRenta"
                        placeholder="Escribe aquí la política de renta que será impresa en el ticket"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.politicaRenta ||
                            'El campo es requerido',
                        ]"
                        required
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        label="Política Venta *"
                        v-model="parametrosEmpresa.politicaVenta"
                        placeholder="Escribe aquí la política de venta que será impresa en el ticket"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.politicaVenta ||
                            'El campo es requerido',
                        ]"
                        required
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Temporizador en minutos notificación de corte de ventas"
                        v-model="
                          parametrosEmpresa.temporizadorCorteVentaMinutos
                        "
                        placeholder="Especifica cada cuantos minutos se deberá mandar una notificación al usuario para que realice el corte de venta en caso de no haberlo hecho"
                        hint="Temporizador en minutos notificación de corte de ventas"
                        type="number"
                        suffix="minutos"
                        :rules="[
                          () =>
                            parametrosEmpresa.temporizadorCorteVentaMinutos >=
                              0 || 'No puede ser negativo!',
                        ]"
                      ></v-text-field>
                      <v-text-field
                        label="Correo electrónico para recibir notificaciones"
                        v-model="
                          parametrosEmpresa.correoNotificacionesCorteCaja
                        "
                        placeholder="Especifica el correo destinatario para las notificaciones."
                        type="text"
                        :rules="[
                          () =>
                            !!parametrosEmpresa.correoNotificacionesCorteCaja ||
                            'El campo es requerido',
                        ]"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Hora indicada para enviar notificaciones entre semana (hh:mm) p. ejem 16:00"
                        v-model="parametrosEmpresa.hrWhatsappEntreSemana"
                        hint="Especifica la hora a partir de la cual se enviará la notificación"
                        mask="##:##"
                        return-masked-value
                        suffix="hrs"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Hora indicada para enviar notificaciones en fin de semana (hh:mm) p. ejem 13:00"
                        v-model="parametrosEmpresa.hrWhatsappFinSemana"
                        hint="Especifica la hora a partir de la cual se enviará la notificación"
                        mask="##:##"
                        return-masked-value
                        suffix="hrs"
                      ></v-text-field>
                    </v-flex>

                     <v-flex xs12 sm12 md12>
                      <v-textarea
                        label="Template whatsapp"
                        v-model="parametrosEmpresa.whatsappTemplate"
                        rows="16"
                      ></v-textarea>
                      <p><b>nombre_cliente:</b> Nombre completo del cliente</p>
                      <p><b>hora:</b> Hora de recolección</p>
                      <p><b>telefono_tienda:</b> Teléfono de la sucursal</p>
                      <p><b>folio_renta:</b> Número de folio de la renta</p>

                    </v-flex>


                      <v-flex xs12 sm12 md12>
                      <v-textarea
                        label="Consulta obtener clientes notificación"
                        v-model="query"
                        rows="8"
                        disabled
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        label="WHERE:"
                        v-model="parametrosEmpresa.filtroConsultaDestinatariosWhatsapp"
                      ></v-textarea>

                       <v-btn fab dark small color="primary" title="Ejecutar consulta" @click="ejecutarRecolecciones">
                        <v-icon dark>launch</v-icon>
                      </v-btn>
                    </v-flex>
                    
                  </v-form>

                    <grid-recolecciones v-show="mostrarRecolecciones" ref="gridRecolecciones"></grid-recolecciones>

                </v-container>
                <br />
                <small>* Indica que el campo es requerido</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-4"
                  :loading="$store.state.operationInProgress"
                  @click="save"
                  >Guardar</v-btn
                >
              </v-card-actions>
              <v-alert
                :value="$store.state.operationSuccess"
                color="success"
                icon="check_circle"
                transition="scale-transition"
                >Parámetros de la empresa guardados con éxito</v-alert
              >
              <v-alert
                :value="$store.state.operationFailed"
                color="error"
                icon="warning"
                transition="scale-transition"
              >
                <span v-html="$store.state.errorMessage"></span>
              </v-alert>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import parametrosEmpresaService from "@/services/parametrosEmpresaService";
import gridRecolecciones from "./GridRecolecciones";


export default {
  components: {
    VWidget,
    gridRecolecciones
  },
  data() {
    return {
      parametrosEmpresa: {
        nombreEmpresa: "",
        razonSocial: "",
        rfc: "",
        domicilioFiscal: "",
        politicaRenta: "",
        politicaVenta: "",
        temporizadorCorteVentaMinutos: null,
        correoNotificacionesCorteCaja: "",
        hrWhatsappEntreSemana: "",
        hrWhatsappFinSemana: "",
        filtroConsultaDestinatariosWhatsapp: "",
        whatsappTemplate: "",
      },
      query: `select DISTINCT 
   Rentas.FolioRenta, 
   [Clientes].NombreCompletoCliente,  
	case when LEN(REPLACE(replace(replace(replace(replace(TelefonoParticular,'-',''),' ',''),' - ',''),')',''), '(', ''))=10 
		   then REPLACE(replace(replace(replace(replace(TelefonoParticular,'-',''),' ',''),' - ',''),')',''), '(', '') 
	     else REPLACE(replace(replace(replace(replace(TelefonoCelular,'-',''),' ',''),' - ',''),')',''), '(', '') end as Telefono 
from [dbo].Rentas 
	inner join  [dbo].[Clientes] on ([Clientes].clienteid= Rentas.clienteid)`,
     mostrarRecolecciones: false
    };
  },
  mounted() {
    this.getParametrosEmpresa();
  },
  methods: {
    getParametrosEmpresa() {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      parametrosEmpresaService
        .get(1)
        .then((result) => {
          self.parametrosEmpresa = result;
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    save() {
      let self = this;

      parametrosEmpresaService
        .update(self.parametrosEmpresa)
        .then((result) => {
          self.operationSuccess();
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    ejecutarRecolecciones(){
      this.mostrarRecolecciones = true;
      this.$refs.gridRecolecciones.getRecolecciones();
    }
  },
};
</script>
